import NoSearchResult from './NoSearchResult';

export * from './types';
export default NoSearchResult;
